import { makeStyles } from '@mui/styles';
import { theme } from '../layout/MaterialLayout';

export default makeStyles(({
  root: {
    minWidth: 275,
  },
  info: {
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
    lineHeight: 1.66,
    borderColor: '#8b9d3e',
    borderRadius: 0,
    textAlign:'center',
    fontSize:theme.typography.pxToRem(16),

    '& .MuiCardContent-root': {
      paddingBottom: 0
    },
    '& a': {
      color: '#fff'
    },
  },

  infoSave: {
    backgroundColor: '#F7F7F8',
    color: '#063006',
    lineHeight: 1.66,
    borderColor: '#EAEAEA',
    borderRadius: 0,

    '& .MuiCardContent-root': {
      paddingBottom: 0
    },

    '& a': {
      color: '#909090 !important'
    }
  },

  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  title: {
    flexGrow: 1,
    fontFamily: theme.typography,
    borderBottom: 14,
    ':after': {
      content: 'test ',
      borderBottom: 14,
      width: 100
    }
  },
  subTitle: {
    flexGrow: 1,
    fontFamily: theme.typography,
    borderBottom: 14,

    ':after': {
      content: 'test ',
      borderBottom: 14,
      width: 100
    }
  },

  stepper: {
    padding: theme.spacing(3, 0, 5),
    padding: '3, 0, 5',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1)
  },
  buttonNext: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
    color: '#fff',
    fontFamily: theme.typography,

    fontWeight: 'bold',
    color: '#fff',
    letterSpacing: 2
  },
  buttonStartNow: {
    marginLeft: theme.spacing(1),
    color: '#fff',
    backgroundColor: theme.palette.secondary.main,
    fontFamily: 'Rockwell-MT',
    fontWeight: 'bold',
    color: '#fff',
    letterSpacing: 2
  },
  buttonBack: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
    fontFamily: theme.typography,
    fontWeight: 'bold',
    letterSpacing: 2,
    color: '#666',
  },
  buttonEdit: {
    fontFamily: theme.typography,
    fontWeight: 'bold',
    letterSpacing: 2,
    color: '#666',
    float: 'right'
  },
  wrapper: {
    margin: theme.spacing(1),
    margin: 1,
    position: 'relative'
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontSize: 15,
    fontWeight: theme.typography.fontWeightRegular
  },
  subTitle: {
    flexGrow: 1,
    fontFamily: theme.typography,
    paddingBottom: 10,
    borderBottom: 14,
    ':after': {
      content: 'test ',
      borderBottom: 14,
      width: 100
    }
  },
  mail: {
    color: theme.palette.secondary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    }
  },
  error: {
    color: theme.palette.error.main,
    fontSize: '0.75rem'
  },

  webinar: {
    '& a': {
      color: theme.palette.secondary.main,
    }
  },

  webinarIntro: {
    flexGrow: 1,
    fontFamily: theme.typography,
    borderBottom: 14,
    ':after': {
      content: 'test ',
      borderBottom: 14,
      width: 100
    }
  },

  stopperLeft: {
    width: '-webkit-fill-available',
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    },
    '& img': {
      width: '-webkit-fill-available',
      height: '-webkit-fill-available'
    }
  },

  stopperRight: {},

  questionsform: {
    marginTop: 24,

  },

  question5Webinar: {
    marginTop: '3.4em'
  },
  success: {
    '& a': {
      color: '#fff'
    }
  },

}));
